/**
 * user_segment_interactions table shape (PR #5490 port): fixed identity
 * columns stay top-level, every other field is packed under custom_fields —
 * on BOTH the Supabase and Firestore write paths, so stored data always has
 * one shape. Readers fall back to the legacy flat keys (pre-table prod docs).
 */

// user_segment_interactions table columns; every other field goes into custom_fields.
export const USER_SEGMENT_INTERACTION_SCHEMA_KEYS = [
  'id',
  'created_at',
  'updated_at',
  'user_id',
  'experience_id',
  'segment_id',
  'segment_interaction_id',
];

// Moves non-column fields into custom_fields — used for both the wire payload and
// the local store record, so stored data always has the same custom_fields shape.
export const moveDynamicFieldsToCustomFields = (data: any): any => {
  if (!data) return data;

  const { custom_fields: existingCustomFields, ...fields } = data;

  const schemaFields: Record<string, any> = {};
  const customFields: Record<string, any> = { ...(existingCustomFields ?? {}) };

  // Split every field: table columns stay top-level, all other fields move into custom_fields.
  Object.entries(fields).forEach(([key, value]) => {
    if (USER_SEGMENT_INTERACTION_SCHEMA_KEYS.includes(key)) {
      schemaFields[key] = value;
    } else {
      customFields[key] = value;
    }
  });

  return { ...schemaFields, custom_fields: customFields };
};

// Playback counts of a segment interaction record — current custom_fields shape,
// then old documents that carry the key flat.
export const selectPlaybackCountsFromSegmentInteraction = (segmentInteraction: any): any[] =>
  segmentInteraction?.custom_fields?.playback_counts ?? segmentInteraction?.playback_counts ?? [];

// Playback resume positions of a segment interaction record — current custom_fields
// shape, then old documents that carry the key flat.
export const selectPlaybackPositionsFromSegmentInteraction = (segmentInteraction: any): any[] =>
  segmentInteraction?.custom_fields?.playback_positions ??
  segmentInteraction?.playback_positions ??
  [];

// Highlighter data of a segment interaction record — current custom_fields shape,
// then old production documents that carry the highlight keys flat.
export const selectHighlighterFromSegmentInteraction = (
  segmentInteraction: any
): { text_highlights: any[]; image_highlights: any[] } => ({
  text_highlights:
    segmentInteraction?.custom_fields?.highlighter?.text_highlights ??
    segmentInteraction?.text_highlights ??
    [],
  image_highlights:
    segmentInteraction?.custom_fields?.highlighter?.image_highlights ??
    segmentInteraction?.image_highlights ??
    [],
});
